import type { MenuOptionComponentProps, MenuOptionResult } from "../../types";
import { MenuButtonRenderer } from "../../ui/MenuOption/MenuButtonRenderer";

export function createMenuOptionComponent(
    useOption: (props: MenuOptionComponentProps) => MenuOptionResult,
) {
    return function MenuOptionComponent(props: MenuOptionComponentProps) {
        const option = useOption(props);

        return <MenuButtonRenderer {...option} name={props.name} />;
    };
}
